<template>
  <div>
    <div :id="id" :style="{height: '400px'}"></div>
  </div>
</template>
<script>
import echarts from 'echarts'
export default {
  props: {
    id: {
      type: String,
      default: () => ''
    },
    data: {
      type: Array,
      default: () => []
    },
    abscissaLine: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    data: {
      handler(newValue) {
        this.drawLine(newValue)
      },
      immediate: false,
    },
  },
  methods: {
    drawLine (data) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById(this.id))
      // 绘制图表
      myChart.setOption({
        title: {
          text: '订单量时段分布图'
        },
        tooltip: {
          trigger: 'axis',
          formatter(params) {
            return "支付笔数：" + params[0]['data'].pay + '笔' + '<br>' + "支付金额：" + params[0]['data'].value + '元'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        lineStyle:{
          color:'#4B7EFE'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.abscissaLine
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '支付笔数',
            type: 'line',
            stack: '总量',
            pay:[1, 3, 4,  5, 6, 7, 8],
            data: data
          }]
      })
    }
  }
}
</script>
<style scoped lang="less">

</style>